import { AxiosResponse } from 'axios';
import { useQuery, UseQueryResult } from 'react-query';
import { TrackingSummary, UrlParams } from 'types';
import { client } from 'utils/api-client';
import { encodeUrlParams } from 'utils/functions';

interface IUseCommittedClubTrackingSummary {
  month?: string;
}

function useCommittedClubTrackingSummary({
  month,
}: IUseCommittedClubTrackingSummary): UseQueryResult<AxiosResponse<TrackingSummary>> {
  return useQuery(['committedClubTrackingSummary', month], () => {
    const params: UrlParams = {};

    if (month) params.month = month;

    return client.get(`check-in-program/tracking/summary/?${encodeUrlParams(params)}`);
  });
}

export default useCommittedClubTrackingSummary;
